import { USER_FEATURES } from "models/user";
import { PROFESSIONAL_CODING_OPTIONS } from "scenes/FacilityPreferences/models/preferences";

import type { UserFeaturesAvailablePackages } from "models/user";
import type { ProfessionalCodingType } from "scenes/FacilityPreferences/models/preferences";

/**
 * Checks whether the organization has the 1Path Professional TEC feature enabled.
 * Managed via the ProFee feature key from `/api/User/Features`.
 */
export const checkProFeeFeature = (userFeatures: UserFeaturesAvailablePackages | null) =>
  !!(userFeatures && userFeatures[USER_FEATURES.ProFee]);

/**
 * Checks if 1Path professional coding is available for the current user based on
 * the ProFee feature, facility settings, and per-user permissions.
 */
export const checkProFeeAllowed = (
  userFeatures: UserFeaturesAvailablePackages | null,
  allowProfessionalCoding?: ProfessionalCodingType,
  allowProfessionalCodingForCurrentUser?: boolean,
): boolean => {
  if (!checkProFeeFeature(userFeatures)) {
    return false;
  }

  if (allowProfessionalCoding === PROFESSIONAL_CODING_OPTIONS.None) {
    return false;
  }

  // If facility is set to "For Individual Users", check the current user's permission
  if (allowProfessionalCoding === PROFESSIONAL_CODING_OPTIONS.ForIndividualUsers) {
    return allowProfessionalCodingForCurrentUser === true;
  }

  // For "For All Users", allow access
  return true;
};
